import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "0516e675-e37f-4685-95b5-827ac6b17b01",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    type: "text",
    prefixText: `Input text answer (1", 1/2", 1/4" or 1/8"):`,
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: `1/2"`,
};
